import { PermissionStatus } from 'expo-location';
import { Platform } from 'react-native';

import {
  LOCATION_GRANT_TYPE_STORAGE_KEY,
  LOCATION_PRIMER_SUPPRESSION_MS,
  LOCATION_PRIMER_SUPPRESSION_STORAGE_KEY,
  PUSH_NOTIFICATION_PRIMER_SUPPRESSION_MS,
  PUSH_NOTIFICATION_PRIMER_SUPPRESSION_STORAGE_KEY,
} from '../permissions.machine.constants';
import { permissionsStorage } from '../permissions.machine.storage';

import type {
  Event,
  RequestLocationPermissionOutput,
  RequestPushNotificationPermissionOutput,
} from '../permissions.machine.types';
import type { ActionArgs, MachineContext } from 'xstate5';

// ─── Internal Actions ────────────────────────────────────────────────────────

export const persistPushNotificationSuppressedUntil = () => {
  permissionsStorage.set(
    PUSH_NOTIFICATION_PRIMER_SUPPRESSION_STORAGE_KEY,
    Date.now() + PUSH_NOTIFICATION_PRIMER_SUPPRESSION_MS,
  );
};

export const persistSuppressedUntil = () => {
  permissionsStorage.set(
    LOCATION_PRIMER_SUPPRESSION_STORAGE_KEY,
    Date.now() + LOCATION_PRIMER_SUPPRESSION_MS,
  );
};

export const persistLocationGrantType = (
  _: ActionArgs<MachineContext, Event, Event>,
  params: RequestLocationPermissionOutput,
) => {
  if (params.status !== PermissionStatus.GRANTED) {
    permissionsStorage.remove(LOCATION_GRANT_TYPE_STORAGE_KEY);
    return;
  }

  const grantType =
    Platform.OS === 'ios' && typeof params.expires === 'number' ? 'allow_once' : 'while_using';

  permissionsStorage.set(LOCATION_GRANT_TYPE_STORAGE_KEY, grantType);
};

export const clearLocationGrantType = () => {
  permissionsStorage.remove(LOCATION_GRANT_TYPE_STORAGE_KEY);
};

// ─── External Actions ────────────────────────────────────────────────────────

export const onPushNotificationPrimerShow = () => undefined;

export const onRequestPushNotificationPermission = () => undefined;

export const onSkipPushNotificationPermission = () => undefined;

export const onLocationPrimerShow = () => undefined;

export const onRequestLocationPermission = () => undefined;

export const onSkipLocationPermission = () => undefined;

export const onAllowOnceDetected = () => undefined;

export const onLocationPermissionGranted = (
  _: ActionArgs<MachineContext, Event, Event>,
  _params: RequestLocationPermissionOutput,
) => undefined;

export const onLocationPermissionDenied = (
  _: ActionArgs<MachineContext, Event, Event>,
  _params?: RequestLocationPermissionOutput,
) => undefined;

export const onPushNotificationPermissionGranted = (
  _: ActionArgs<MachineContext, Event, Event>,
  _params: RequestPushNotificationPermissionOutput,
) => undefined;

export const onPushNotificationPermissionDenied = (
  _: ActionArgs<MachineContext, Event, Event>,
  _params?: RequestPushNotificationPermissionOutput,
) => undefined;
